var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39062 0C3.07812 0 2.04688 1.07812 2.04688 2.39062V27.6562C2.04688 28.9688 3.07812 30 4.39062 30H25.8594C27.1719 30 28.25 28.9688 28.25 27.6562V9.5625L19.3906 0H4.39062Z",
    fill: "#49C9A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 9.5625V10.0312H22.25C22.25 10.0312 19.2969 9.42188 19.3438 6.84375C19.3438 6.84375 19.4844 9.5625 22.2031 9.5625H28.25Z",
    fill: "#37BB91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.3906 0V6.84375C19.3906 7.59375 19.9062 9.5625 22.25 9.5625H28.25L19.3906 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73438 25.1719V15.375H16.5312V25.1719H6.73438ZM15.5469 16.3594H7.71875V22.2656H15.5469V16.3594ZM11.0469 20.2969L12.875 17.8125L13.4844 18.7969L14.0938 18.6094L14.5625 21.2344H8.42188L10.0625 19.6875L11.0469 20.2969ZM9.26562 18.5625C8.84375 18.5625 8.46875 18.2812 8.46875 17.8594C8.46875 17.4844 8.84375 17.1562 9.26562 17.1562C9.6875 17.1562 10.0156 17.4844 10.0156 17.8594C10.0156 18.2812 9.6875 18.5625 9.26562 18.5625Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.7511c38cf0dfe51851843560ac1a718f.svg";
export { ForwardRef as ReactComponent };